import './ArticlePage.scss'

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Col, Container, Row } from 'react-bootstrap'
import parse from 'html-react-parser'

import Loading from '../../../templates/Loading'
import WebShare from '../../web-share'
import Error from '../../common/error/Error'
import AccountMenu from '../../common/navigation/AccountMenu'
import { getRembleArticlesByID } from 'components/common/api/Articles'
import { ROUTE_TODAY } from 'components/common/helpers/Paths'
import {
  EVENT_ACTION_PAGEVIEW,
  EVENT_CATEGORY_ARTICLE,
  saveUserEvent
} from 'components/common/api/UserEvents'

/**
 * Article Page component. Used to pull post content straight from WP api
 */
export default function ArticlePage({ setHeaderTitle, setReturnPath }) {
  const { articleId } = useParams()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(true)
  const [content, setContent] = useState()
  const [title, setTitle] = useState()
  const [image, setImage] = useState()

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)
    ;(async function getArticlePageAsync() {
      const result = await getRembleArticlesByID(articleId)
      if (!result) {
        setError(
          'Unable to fetch the article page at this time. Please try again later.'
        )
      }

      const articleResult = result
      setTitle(articleResult?.title?.rendered)
      setHeaderTitle(null)
      setContent(articleResult?.content?.rendered)
      setImage(articleResult?.featured_image_url ?? '')
      setReturnPath(ROUTE_TODAY)
      setLoading(false)

      // Log access to the article page
      saveUserEvent(EVENT_CATEGORY_ARTICLE, EVENT_ACTION_PAGEVIEW, articleId)
    })()
  }, [articleId, setHeaderTitle, setReturnPath])

  return (
    <Loading isLoaded={loading}>
      <Container id='top' className='article-page-container'>
        <Error error={error} />
        <div className='fixed-buttons position-fixed d-flex align-items-center justify-content-between flex-column'>
          <WebShare
            text={title}
            color='text-black'
            size='fs-3'
            buttonClass='article-share-button'
          />
          <a href='#top' className='top-link'>
            <i className='bi bi-arrow-up-circle-fill fs-1' />
          </a>
        </div>
        <Row className='justify-content-center'>
          {/* Sidebar panel for larger screens */}
          <Col md={4} className='mobile-hidden account-sidebar'>
            <AccountMenu />
          </Col>
          <Col sm={10} md={8}>
            {!loading && (
              <>
                <h1 className='title'>{parse(title)}</h1>
                <div className='content-wrapper'>
                  <img
                    fetchpriority='high'
                    className='my-4'
                    src={image}
                    alt=''
                  />
                  {parse(content)}
                </div>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </Loading>
  )
}
